import { render } from "./FilterArea.vue?vue&type=template&id=5c8216e2"
import script from "./FilterArea.vue?vue&type=script&lang=js"
export * from "./FilterArea.vue?vue&type=script&lang=js"
script.render = render

export default script